// extracted by mini-css-extract-plugin
export default {"img1":"home_img1__Lhoj1","btn1":"home_btn1__ow4bN","main2":"home_main2__NQQUs","main3":"home_main3__y9C-3","img2":"home_img2__U70BC","main":"home_main__z9ZSl"};